<template>
  <div class="paper">
    <div class="title row">
      <title class="color bold larger text-center">{{paper.title}}</title>
      <div class="nav">
        <a @click="prev"><v-icon class="m8" name="arrow-left"/></a>
      </div>  
      <div class="action">
        <div class="nav">
          <a @click="next"><v-icon class="m8" name="arrow-right"/></a>
        </div>  
      </div>
    </div>
    <content class="row" v-html="content"></content>
    <div class="edit">
      <router-link v-if="canEdit()" :to="edit" title="Modifier">
        <v-icon class="m8" name="edit"/>
      </router-link>
    </div>
    <div class="date">{{formatDate(paper.created)}}</div>
    <social-sharing :url="url"
                    :title="title"
                    description="Site officiel de l'Avenir Sport. Club de football de Saint-Pierre-Montlimart et de Montrevault"
                    hashtags="avenirsport"
                    twitter-user=""                    
                    inline-template>
      <div>
        <network network="facebook">
          <v-icon class="m8" name="brands/facebook"/>
        </network>
        <network network="twitter">
          <v-icon class="m8" name="brands/twitter"/>
        </network>
      </div>
    </social-sharing>
    <viewer ref="viewer" class="images" :images="images" @inited="inited">
      <img class="image" v-for="file in images" :src="paper.image(file)" :key="paper.image(file)"/>
    </viewer>
    <div class="item box" v-for="file in files" :key="file.id" @click="showViewer">
      <v-img :src="paper.image(file)"/>
      <!--<img :src="paper.image(file)"/>-->
    </div>
  </div>
</template>

<script>
  import 'viewerjs/dist/viewer.css'
  import Viewer from "v-viewer/src/component.vue"
  import moment from 'moment'

  import PaperService from '../../services/paper.service'
  import MetaService from '../../services/meta.service'

  import Vue from 'vue'

  Vue.use(Viewer)

  export default {
    context: {
      auth: {
        type: Object,
        default: null
      }
    },    
    metaInfo() {
      if (!this.title) return
      const META_INFO = {
        url : this.url,
        title : this.metaInfo.title,
        image : this.metaInfo.image,
        description : this.metaInfo.description
      }
      const metaInfo = MetaService.info(META_INFO)
      console.log("metaInfo", metaInfo)
      return metaInfo;
    },
    name: 'Paper',
    props: {},
    components: {
      Viewer
    },
    methods: {
      inited (viewer) {
        this.$viewer = viewer
      },
      formatDate(date) {
        return moment(date).format('DD-MM-YY')
      },      
      showViewer() {
        this.images = this.paper.files;
        _.delay(() => this.$viewer.show(), 1000)
      },
      fetch(direction = 1) {
        console.log("next");
        const papers = PaperService.getPapers()
        const index = _.indexOf(_.map(papers, "key"), this.paper.key)
        if (index > -1 && index + direction < papers.length) {
          const shift = index + direction
          if (shift < 0) return
          const paper = _.get(papers, `${shift}`);
          const path = `/news/${_.get(paper, "deeplink")}`;
          this.$router.push({path})
          this.bind(paper)
        } else {
          if (this.paper.created === _.get(papers, "0.created")) return
          PaperService.fetch()
            .delay(100)
            .then(() => {
              this.fetch(direction)
            })
        }
      },
      next() {
        console.log("next");
        this.fetch()
        if (!this.isShow(this.paper)) {
          this.next()
        }
      },
      prev() {
        console.log("prev");
        this.fetch(-1)
        if (!this.isShow(this.paper)) {
          const papers = PaperService.getPapers()
          const index = _.indexOf(_.map(papers, "key"), this.paper.key)
          if (index > -1) this.prev()
        }
      },
      canEdit() {
        return PaperService.canEdit(this.paper)
      },
      isShow(item) {
        /* display if published or admin or owner*/
        return PaperService.isShow(item)
      },
      bind(paper) {
        if (_.isNil(paper)) return
        const deeplink = _.get(this, "$route.params.id")
        this.edit = "/edit/" + deeplink
        this.paper = paper
        this.url = PaperService.getShareLink(paper)
        this.title = PaperService.getShareTitle(paper)
        this.content = this.paper.html
        console.log(this.url)
        this.files = []
        _.delay(() => this.files = this.paper.files || [], 100)
        this.setMetaInfo()
      },
      setMetaInfo() {
        const title = PaperService.getShareTitle(this.paper)
        const file = _.get(this, "paper.files.0")
        const image = _.invoke(this.paper, "image", file)
        const description = _.invoke(this.paper, "extract")
        this.metaInfo = {
          title, image, description
        }
      }
    },
    created() {
      const deeplink = _.get(this, "$route.params.id")
      this.edit = "/edit/" + deeplink
      if (_.isNil(deeplink)) return false
      this.paper = {};
      this.content = "";
      this.$root.$data.paper.deeplink(deeplink)
        .then(paper => this.bind(paper))
    },
    data() {
      return {
        paper: {},
        edit: "",
        url: "",
        title: "",
        content: "",
        files: [],
        images: [],
        metaInfo: {}
      }
    }
  }
</script>

<style scoped lang="stylus">
  .paper
    .title
      text-align center
    .nav
      float left
      border 1px solid #ccc
      border-radius 5px
      padding 5px
      margin 2px
    .action
      float right
      margin-top 5px
    title
      display inline-block
      max-width 75%
    content
      display block
    .images
      .image
        display none
    .date
      float right
      bottom 8px
      right 10px
      font-size smaller
    .edit
      float left
      font-size smaller
      margin-top 2px
    .social
      position absolute
      bottom 5px
      right 70px
      font-size smaller  
</style>
